/** Shared in-tab toggle for consolidated admin sections. Optional per-tab badge
 *  shows a count (amber when it needs action, neutral otherwise). */
export function SubTabBar({ tabs, active, onChange }: {
  tabs: { v: string; label: string; badge?: number; badgeUrgent?: boolean }[];
  active: string;
  onChange: (v: string) => void;
}) {
  return (
    <div style={{ display: 'flex', gap: 6, marginBottom: 18, flexWrap: 'wrap' }}>
      {tabs.map((tb) => {
        const on = active === tb.v;
        return (
          <button key={tb.v} type="button" onClick={() => onChange(tb.v)}
            style={{
              padding: '7px 14px', borderRadius: 8, cursor: 'pointer', fontFamily: 'inherit', fontSize: 'var(--fs-body)',
              border: on ? '1px solid transparent' : '1px solid rgba(15,45,100,0.5)',
              background: on ? 'rgba(74,158,255,0.16)' : 'transparent',
              color: on ? '#bcd9ff' : '#9aa',
              display: 'inline-flex', alignItems: 'center', gap: 7,
            }}>
            {tb.label}
            {tb.badge ? (
              <span style={{
                fontSize: 'var(--fs-caption)', fontWeight: 600, lineHeight: 1, padding: '2px 7px', borderRadius: 999,
                color: tb.badgeUrgent ? '#f1c40f' : '#8ab4ff',
                background: tb.badgeUrgent ? 'rgba(241,196,15,0.14)' : 'rgba(74,158,255,0.16)',
                border: `1px solid ${tb.badgeUrgent ? 'rgba(241,196,15,0.4)' : 'rgba(74,158,255,0.35)'}`,
              }}>{tb.badge}</span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
